// System
import { Stack, Typography, Box } from '@mui/material';

// Redux
import { useMinesRoundDrawer } from '@Modal/hooks/rounds/useMinesRoundDrawer';

export const SetupMinesRoundHeader: React.FC = () => {
  const { selectedRoundData } = useMinesRoundDrawer();
  return (
    <Stack>
      <Box>
        <Typography variant="h6">
          {selectedRoundData?._id ? selectedRoundData?._id : 'No Result'}
        </Typography>
      </Box>
    </Stack>
  );
};
